import React, { useState } from "react";
const emailUsername = process.env.REACT_APP_EMAIL_USERNAME;
const emailPassword = process.env.REACT_APP_EMAIL_PASSWORD;
const emailSecureToken = process.env.REACT_APP_SECURE_TOKEN;
const emailHost = process.env.REACT_APP_HOST;
const emailPort = process.env.REACT_APP_PORT;
const emailFrom = process.env.REACT_APP_FROM;
const emailTo = process.env.REACT_APP_TO;

const SeoCheckingForm = () => {
  const [formData, setFormData] = useState({
    url: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const inputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();

      const config = {
        Username: emailUsername,
        Password: emailPassword,
        SecureToken: emailSecureToken,
        Host: emailHost,
        Port: emailPort,
        From: emailFrom,
        To: emailTo,
        Subject: "SEO Checking Form - Quick Seo Website",
        Body: `
        Hi,
        <br />
        <br />
        These are Seo checking Clients site form details from Quick Seo Website.
        <br /> 
        <br />
        <strong>Email</strong> - ${formData.email} 
        <br/>
        <strong>URL</strong> - ${formData.url} 
        <br />
        <br />
        <br />
        Thank you
        <br />
        <br />
        <br />
       
        `,
      };

      if (window.Email) {
        await window.Email.send(config)
          .then((message) => console.log(message, "Message sent Successfully"))
          .catch((error) => {
            console.log(error);
          });
      }

      setLoading(true);

      // Optionally, you can show a success message or perform other actions

      setFormData({
        url: "",
        email: "",
      });
      setSuccessMessage("Message received! We will get back to you soon.");
    } catch (error) {
      console.error(
        "Error submitting form:",
        error.response ? error.response.data : error.message
      );
      // Optionally, you can show an error message to the user
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <input
            type="url"
            name="url"
            onChange={inputChange}
            value={formData.url}
            className="seo-form-input input-web-url"
            placeholder="Type website URL"
            required
            autoComplete="off"
          />
          <input
            type="email"
            onChange={inputChange}
            className="seo-form-input seo-form-email-input"
            name="email"
            value={formData.email}
            placeholder="Your Email"
            autoComplete="off"
            required
          />
          <button type="submit" className="seo-form-btn" disabled={loading}>
            {loading ? "Submitting..." : "Submit Now"}
          </button>
        </form>

        <div className="text-center">
          <center className="text-center py-3 text-white">
            {successMessage && <h6>{successMessage}</h6>}
          </center>
        </div>
      </div>
    </>
  );
};

export default SeoCheckingForm;
